import PropTypes from "prop-types";
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	StyleSheet,
	View
} from "react-native";

import prop from "prop";
import Output from "../Outputs/Output";
import InputContainer from "../Inputs/Layout/InputContainer";
import InputLabel from "../Inputs/Layout/InputLabel";
import StyledText from "ae-base/Base/StyledText";
import Style from "ae-style";
import getSchemaFromPath from "json-schema-from-path";

var FINDNUMBER = /\d+/g;

var styles = StyleSheet.create({
	items: {
		marginVertical: Style.layout.marginSmall
	},
	copypaste: {
		WebkitUserSelect: "text",  /* Chrome all / Safari all */
	}
});

export default function OutputChange(props, context) {
	var localize = context.localize;
	var schema = props.schema || {};
	var changes = props.changes;
	var operation;
	var opTitle = localize("changes.operation");
	var allChanges;
	var containerStyles = [props.style, styles.copypaste]

	allChanges = changes.map(function(element){
		var path = element.path;
		var changeSchema = getSchemaFromPath(schema, path);
		operation = localize("changes" + "." + element.op);
		var dataText = element.value ? element.value : " ";
		var pathArray = path.split("/");
		var readablePath = pathArray.reduce(function(result,subPath) {
			var isNumber = subPath.match(FINDNUMBER);
			if(isNumber) {
				return result.concat((parseInt(subPath) + 1).toString());
			} else return result;
		}, []).join(" - ");
		var operationText = operation + " " + readablePath;

		return(
			<View>
			    <StyledText style={styles.items} contrast={props.contrast} standard bold>
				    {opTitle} {operationText}
			    </StyledText>
				<View style={styles.copypaste}>
					<Output key={path} schema={changeSchema} data={dataText} contrast={props.contrast} />
				</View>
			</View>
		);
	});

	return (
		<InputContainer style={containerStyles}>
			<InputLabel schema={schema} contrast={props.contrast} />
				{allChanges}
		</InputContainer>
	);
}

OutputChange.contextTypes = {
	localize: PropTypes.func
};
